export const roles = [
  'Academic / Educator',
  'Business - Exec / VP',
  'Business - Professional',
  'CEO / President / Founder',
  'Data Scientist / Data Engineer',
  'Industry Analyst',
  'IT - CIO / VP',
  'IT - Director / Manager',
  'IT - Engineer / Developer',
  'IT - Solution / System Architect',
  'IT - System Admin',
  'Security Professional',
  'Researcher',
  'Other',
];

export const statesFrance = [
  { name: 'Auvergne-Rhône-Alpes', code: 'ARA' },
  { name: 'Bourgogne-Franche-Comté', code: 'BFC' },
  { name: 'Bretagne', code: 'BRE' },
  { name: 'Centre-Val de Loire', code: 'CVL' },
  { name: 'Corse', code: 'COR' },
  { name: 'Grand Est', code: 'GRE' },
  { name: 'Guadeloupe', code: 'GUA' },
  { name: 'Guyane', code: 'GF' },
  { name: 'Hauts-de-France', code: 'HDF' },
  { name: 'Île-de-France', code: 'IDF' },
  { name: 'La Réunion', code: 'LRE' },
  { name: 'Martinique', code: 'MQ' },
  { name: 'Mayotte', code: 'MAY' },
  { name: 'Normandie', code: 'NOR' },
  { name: 'Nouvelle-Aquitaine', code: 'NAQ' },
  { name: 'Occitanie', code: 'OCC' },
  { name: 'Pays de la Loire', code: 'PDL' },
  { name: "Provence-Alpes-Côte d'Azur", code: 'PAC' },
];

export const statesJapan = [
  {
    name: 'Aiti',
    code: '23',
  },
  {
    name: 'Akita',
    code: '05',
  },
  {
    name: 'Aomori',
    code: '02',
  },
  {
    name: 'Ehime',
    code: '38',
  },
  {
    name: 'Gihu',
    code: '21',
  },
  {
    name: 'Gunma',
    code: '10',
  },
  {
    name: 'Hirosima',
    code: '34',
  },
  {
    name: 'Hokkaidô',
    code: '01',
  },
  {
    name: 'Hukui',
    code: '18',
  },
  {
    name: 'Hukuoka',
    code: '40',
  },
  {
    name: 'Hukusima',
    code: '07',
  },
  {
    name: 'Hyôgo',
    code: '28',
  },
  {
    name: 'Ibaraki',
    code: '08',
  },
  {
    name: 'Isikawa',
    code: '17',
  },
  {
    name: 'Iwate',
    code: '03',
  },
  {
    name: 'Kagawa',
    code: '37',
  },
  {
    name: 'Kagosima',
    code: '46',
  },
  {
    name: 'Kanagawa',
    code: '14',
  },
  {
    name: 'Kumamoto',
    code: '43',
  },
  {
    name: 'Kyôto',
    code: '26',
  },
  {
    name: 'Kôti',
    code: '39',
  },
  {
    name: 'Mie',
    code: '24',
  },
  {
    name: 'Miyagi',
    code: '04',
  },
  {
    name: 'Miyazaki',
    code: '45',
  },
  {
    name: 'Nagano',
    code: '20',
  },
  {
    name: 'Nagasaki',
    code: '42',
  },
  {
    name: 'Nara',
    code: '29',
  },
  {
    name: 'Niigata',
    code: '15',
  },
  {
    name: 'Okayama',
    code: '33',
  },
  {
    name: 'Okinawa',
    code: '47',
  },
  {
    name: 'Saga',
    code: '41',
  },
  {
    name: 'Saitama',
    code: '11',
  },
  {
    name: 'Siga',
    code: '25',
  },
  {
    name: 'Simane',
    code: '32',
  },
  {
    name: 'Sizuoka',
    code: '22',
  },
  {
    name: 'Tiba',
    code: '12',
  },
  {
    name: 'Tokusima',
    code: '36',
  },
  {
    name: 'Totigi',
    code: '09',
  },
  {
    name: 'Tottori',
    code: '31',
  },
  {
    name: 'Toyama',
    code: '16',
  },
  {
    name: 'Tôkyô',
    code: '13',
  },
  {
    name: 'Wakayama',
    code: '30',
  },
  {
    name: 'Yamagata',
    code: '06',
  },
  {
    name: 'Yamaguti',
    code: '35',
  },
  {
    name: 'Yamanasi',
    code: '19',
  },
  {
    name: 'Ôita',
    code: '44',
  },
  {
    name: 'Ôsaka',
    code: '27',
  },
];

export const statesBrazil = [
  {
    id_uf: 1,
    code: 'AC',
    name: 'Acre',
    codigo: 12,
    id_pais: 1,
  },
  {
    id_uf: 2,
    code: 'AL',
    name: 'Alagoas',
    codigo: 27,
    id_pais: 1,
  },
  {
    id_uf: 3,
    code: 'AM',
    name: 'Amazonas',
    codigo: 13,
    id_pais: 1,
  },
  {
    id_uf: 4,
    code: 'AP',
    name: 'Amapá',
    codigo: 16,
    id_pais: 1,
  },
  {
    id_uf: 5,
    code: 'BA',
    name: 'Bahia',
    codigo: 29,
    id_pais: 1,
  },
  {
    id_uf: 6,
    code: 'CE',
    name: 'Ceará',
    codigo: 23,
    id_pais: 1,
  },
  {
    id_uf: 7,
    code: 'DF',
    name: 'Distrito Federal',
    codigo: 53,
    id_pais: 1,
  },
  {
    id_uf: 8,
    code: 'ES',
    name: 'Espírito Santo',
    codigo: 32,
    id_pais: 1,
  },
  {
    id_uf: 9,
    code: 'GO',
    name: 'Goiás',
    codigo: 52,
    id_pais: 1,
  },
  {
    id_uf: 10,
    code: 'MA',
    name: 'Maranhão',
    codigo: 21,
    id_pais: 1,
  },
  {
    id_uf: 11,
    code: 'MG',
    name: 'Minas Gerais',
    codigo: 31,
    id_pais: 1,
  },
  {
    id_uf: 12,
    code: 'MS',
    name: 'Mato Grosso do Sul',
    codigo: 50,
    id_pais: 1,
  },
  {
    id_uf: 13,
    code: 'MT',
    name: 'Mato Grosso',
    codigo: 51,
    id_pais: 1,
  },
  {
    id_uf: 14,
    code: 'PA',
    name: 'Pará',
    codigo: 15,
    id_pais: 1,
  },
  {
    id_uf: 15,
    code: 'PB',
    name: 'Paraíba',
    codigo: 25,
    id_pais: 1,
  },
  {
    id_uf: 16,
    code: 'PE',
    name: 'Pernambuco',
    codigo: 26,
    id_pais: 1,
  },
  {
    id_uf: 17,
    code: 'PI',
    name: 'Piauí',
    codigo: 22,
    id_pais: 1,
  },
  {
    id_uf: 18,
    code: 'PR',
    name: 'Paraná',
    codigo: 41,
    id_pais: 1,
  },
  {
    id_uf: 19,
    code: 'RJ',
    name: 'Rio de Janeiro',
    codigo: 33,
    id_pais: 1,
  },
  {
    id_uf: 20,
    code: 'RN',
    name: 'Rio Grande do Norte',
    codigo: 24,
    id_pais: 1,
  },
  {
    id_uf: 21,
    code: 'RO',
    name: 'Rondônia',
    codigo: 11,
    id_pais: 1,
  },
  {
    id_uf: 22,
    code: 'RR',
    name: 'Roraima',
    codigo: 14,
    id_pais: 1,
  },
  {
    id_uf: 23,
    code: 'RS',
    name: 'Rio Grande do Sul',
    codigo: 43,
    id_pais: 1,
  },
  {
    id_uf: 24,
    code: 'SC',
    name: 'Santa Catarina',
    codigo: 42,
    id_pais: 1,
  },
  {
    id_uf: 25,
    code: 'SE',
    name: 'Sergipe',
    codigo: 28,
    id_pais: 1,
  },
  {
    id_uf: 26,
    code: 'SP',
    name: 'São Paulo',
    codigo: 35,
    id_pais: 1,
  },
  {
    id_uf: 27,
    code: 'TO',
    name: 'Tocantins',
    codigo: 17,
    id_pais: 1,
  },
];

export const statesAustralia = [
  {
    name: 'New South Wales',
    code: 'NSW',
  },
  {
    name: 'Victoria',
    code: 'VIC',
  },
  {
    name: 'Queensland',
    code: 'QLD',
  },
  {
    name: 'Tasmania',
    code: 'TAS',
  },
  {
    name: 'South Australia',
    code: 'SA',
  },
  {
    name: 'Western Australia',
    code: 'WA',
  },
  {
    name: 'Northern Territory',
    code: 'NT',
  },
  {
    name: 'Australian Capital Territory',
    code: 'ACT',
  },
];

export const statesCanada = [
  {
    name: 'Alberta',
    code: 'AB',
  },
  {
    name: 'British Columbia',
    code: 'BC',
  },
  {
    name: 'Manitoba',
    code: 'MB',
  },
  {
    name: 'New Brunswick',
    code: 'NB',
  },
  {
    name: 'Newfoundland and Labrador',
    code: 'NL',
  },
  {
    name: 'Northwest Territories',
    code: 'NT',
  },
  {
    name: 'Nova Scotia',
    code: 'NS',
  },
  {
    name: 'Nunavut',
    code: 'NU',
  },
  {
    name: 'Ontario',
    code: 'ON',
  },
  {
    name: 'Prince Edward Island',
    code: 'PE',
  },
  {
    name: 'Quebec',
    code: 'QC',
  },
  {
    name: 'Saskatchewan',
    code: 'SK',
  },
  {
    name: 'Yukon Territory',
    code: 'YT',
  },
];

export const statesUSA = [
  {
    name: 'Alabama',
    code: 'AL',
  },
  {
    name: 'Alaska',
    code: 'AK',
  },
  {
    name: 'American Samoa',
    code: 'AS',
  },
  {
    name: 'Arizona',
    code: 'AZ',
  },
  {
    name: 'Arkansas',
    code: 'AR',
  },
  {
    name: 'California',
    code: 'CA',
  },
  {
    name: 'Colorado',
    code: 'CO',
  },
  {
    name: 'Connecticut',
    code: 'CT',
  },
  {
    name: 'Delaware',
    code: 'DE',
  },
  {
    name: 'District Of Columbia',
    code: 'DC',
  },
  {
    name: 'Federated States Of Micronesia',
    code: 'FM',
  },
  {
    name: 'Florida',
    code: 'FL',
  },
  {
    name: 'Georgia',
    code: 'GA',
  },
  {
    name: 'Guam',
    code: 'GU',
  },
  {
    name: 'Hawaii',
    code: 'HI',
  },
  {
    name: 'Idaho',
    code: 'ID',
  },
  {
    name: 'Illinois',
    code: 'IL',
  },
  {
    name: 'Indiana',
    code: 'IN',
  },
  {
    name: 'Iowa',
    code: 'IA',
  },
  {
    name: 'Kansas',
    code: 'KS',
  },
  {
    name: 'Kentucky',
    code: 'KY',
  },
  {
    name: 'Louisiana',
    code: 'LA',
  },
  {
    name: 'Maine',
    code: 'ME',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
  },
  {
    name: 'Maryland',
    code: 'MD',
  },
  {
    name: 'Massachusetts',
    code: 'MA',
  },
  {
    name: 'Michigan',
    code: 'MI',
  },
  {
    name: 'Minnesota',
    code: 'MN',
  },
  {
    name: 'Mississippi',
    code: 'MS',
  },
  {
    name: 'Missouri',
    code: 'MO',
  },
  {
    name: 'Montana',
    code: 'MT',
  },
  {
    name: 'Nebraska',
    code: 'NE',
  },
  {
    name: 'Nevada',
    code: 'NV',
  },
  {
    name: 'New Hampshire',
    code: 'NH',
  },
  {
    name: 'New Jersey',
    code: 'NJ',
  },
  {
    name: 'New Mexico',
    code: 'NM',
  },
  {
    name: 'New York',
    code: 'NY',
  },
  {
    name: 'North Carolina',
    code: 'NC',
  },
  {
    name: 'North Dakota',
    code: 'ND',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
  },
  {
    name: 'Ohio',
    code: 'OH',
  },
  {
    name: 'Oklahoma',
    code: 'OK',
  },
  {
    name: 'Oregon',
    code: 'OR',
  },
  {
    name: 'Palau',
    code: 'PW',
  },
  {
    name: 'Pennsylvania',
    code: 'PA',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
  },
  {
    name: 'Rhode Island',
    code: 'RI',
  },
  {
    name: 'South Carolina',
    code: 'SC',
  },
  {
    name: 'South Dakota',
    code: 'SD',
  },
  {
    name: 'Tennessee',
    code: 'TN',
  },
  {
    name: 'Texas',
    code: 'TX',
  },
  {
    name: 'Utah',
    code: 'UT',
  },
  {
    name: 'Vermont',
    code: 'VT',
  },
  {
    name: 'Virgin Islands',
    code: 'VI',
  },
  {
    name: 'Virginia',
    code: 'VA',
  },
  {
    name: 'Washington',
    code: 'WA',
  },
  {
    name: 'West Virginia',
    code: 'WV',
  },
  {
    name: 'Wisconsin',
    code: 'WI',
  },
  {
    name: 'Wyoming',
    code: 'WY',
  },
];

export const countries = [
  {
    name: 'United States',
    code: 'US',
  },
  {
    name: 'Canada',
    code: 'CA',
  },
  {
    name: 'Afghanistan',
    code: 'AF',
  },
  {
    name: 'Åland Islands',
    code: 'AX',
  },
  {
    name: 'Albania',
    code: 'AL',
  },
  {
    name: 'Algeria',
    code: 'DZ',
  },
  {
    name: 'American Samoa',
    code: 'AS',
  },
  {
    name: 'Andorra',
    code: 'AD',
  },
  {
    name: 'Angola',
    code: 'AO',
  },
  {
    name: 'Anguilla',
    code: 'AI',
  },
  {
    name: 'Antarctica',
    code: 'AQ',
  },
  {
    name: 'Antigua and Barbuda',
    code: 'AG',
  },
  {
    name: 'Argentina',
    code: 'AR',
  },
  {
    name: 'Armenia',
    code: 'AM',
  },
  {
    name: 'Aruba',
    code: 'AW',
  },
  {
    name: 'Australia',
    code: 'AU',
  },
  {
    name: 'Austria',
    code: 'AT',
  },
  {
    name: 'Azerbaijan',
    code: 'AZ',
  },
  {
    name: 'Bahamas',
    code: 'BS',
  },
  {
    name: 'Bahrain',
    code: 'BH',
  },
  {
    name: 'Bangladesh',
    code: 'BD',
  },
  {
    name: 'Barbados',
    code: 'BB',
  },
  {
    name: 'Belarus',
    code: 'BY',
  },
  {
    name: 'Belgium',
    code: 'BE',
  },
  {
    name: 'Belize',
    code: 'BZ',
  },
  {
    name: 'Benin',
    code: 'BJ',
  },
  {
    name: 'Bermuda',
    code: 'BM',
  },
  {
    name: 'Bhutan',
    code: 'BT',
  },
  {
    name: 'Bolivia',
    code: 'BO',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: 'BA',
  },
  {
    name: 'Botswana',
    code: 'BW',
  },
  {
    name: 'Bouvet Island',
    code: 'BV',
  },
  {
    name: 'Brazil',
    code: 'BR',
  },
  {
    name: 'British Indian Ocean Territory',
    code: 'IO',
  },
  {
    name: 'Brunei Darussalam',
    code: 'BN',
  },
  {
    name: 'Bulgaria',
    code: 'BG',
  },
  {
    name: 'Burkina Faso',
    code: 'BF',
  },
  {
    name: 'Burundi',
    code: 'BI',
  },
  {
    name: 'Cambodia',
    code: 'KH',
  },
  {
    name: 'Cameroon',
    code: 'CM',
  },
  {
    name: 'Cape Verde',
    code: 'CV',
  },
  {
    name: 'Cayman Islands',
    code: 'KY',
  },
  {
    name: 'Central African Republic',
    code: 'CF',
  },
  {
    name: 'Chad',
    code: 'TD',
  },
  {
    name: 'Chile',
    code: 'CL',
  },
  {
    name: 'China',
    code: 'CN',
  },
  {
    name: 'Christmas Island',
    code: 'CX',
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: 'CC',
  },
  {
    name: 'Colombia',
    code: 'CO',
  },
  {
    name: 'Comoros',
    code: 'KM',
  },
  {
    name: 'Congo',
    code: 'CG',
  },
  {
    name: 'Congo, Democratic Republic',
    code: 'CD',
  },
  {
    name: 'Cook Islands',
    code: 'CK',
  },
  {
    name: 'Costa Rica',
    code: 'CR',
  },
  {
    name: 'Cote D"Ivoire',
    code: 'CI',
  },
  {
    name: 'Croatia',
    code: 'HR',
  },
  {
    name: 'Cuba',
    code: 'CU',
  },
  {
    name: 'Cyprus',
    code: 'CY',
  },
  {
    name: 'Czech Republic',
    code: 'CZ',
  },
  {
    name: 'Denmark',
    code: 'DK',
  },
  {
    name: 'Djibouti',
    code: 'DJ',
  },
  {
    name: 'Dominica',
    code: 'DM',
  },
  {
    name: 'Dominican Republic',
    code: 'DO',
  },
  {
    name: 'Ecuador',
    code: 'EC',
  },
  {
    name: 'Egypt',
    code: 'EG',
  },
  {
    name: 'El Salvador',
    code: 'SV',
  },
  {
    name: 'Equatorial Guinea',
    code: 'GQ',
  },
  {
    name: 'Eritrea',
    code: 'ER',
  },
  {
    name: 'Estonia',
    code: 'EE',
  },
  {
    name: 'Ethiopia',
    code: 'ET',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: 'FK',
  },
  {
    name: 'Faroe Islands',
    code: 'FO',
  },
  {
    name: 'Fiji',
    code: 'FJ',
  },
  {
    name: 'Finland',
    code: 'FI',
  },
  {
    name: 'France',
    code: 'FR',
  },
  {
    name: 'French Guiana',
    code: 'GF',
  },
  {
    name: 'French Polynesia',
    code: 'PF',
  },
  {
    name: 'French Southern Territories',
    code: 'TF',
  },
  {
    name: 'Gabon',
    code: 'GA',
  },
  {
    name: 'Gambia',
    code: 'GM',
  },
  {
    name: 'Georgia',
    code: 'GE',
  },
  {
    name: 'Germany',
    code: 'DE',
  },
  {
    name: 'Ghana',
    code: 'GH',
  },
  {
    name: 'Gibraltar',
    code: 'GI',
  },
  {
    name: 'Greece',
    code: 'GR',
  },
  {
    name: 'Greenland',
    code: 'GL',
  },
  {
    name: 'Grenada',
    code: 'GD',
  },
  {
    name: 'Guadeloupe',
    code: 'GP',
  },
  {
    name: 'Guam',
    code: 'GU',
  },
  {
    name: 'Guatemala',
    code: 'GT',
  },
  {
    name: 'Guernsey',
    code: 'GG',
  },
  {
    name: 'Guinea',
    code: 'GN',
  },
  {
    name: 'Guinea-Bissau',
    code: 'GW',
  },
  {
    name: 'Guyana',
    code: 'GY',
  },
  {
    name: 'Haiti',
    code: 'HT',
  },
  {
    name: 'Heard Island and Mcdonald Islands',
    code: 'HM',
  },
  {
    name: 'Holy See (Vatican City State)',
    code: 'VA',
  },
  {
    name: 'Honduras',
    code: 'HN',
  },
  {
    name: 'Hong Kong',
    code: 'HK',
  },
  {
    name: 'Hungary',
    code: 'HU',
  },
  {
    name: 'Iceland',
    code: 'IS',
  },
  {
    name: 'India',
    code: 'IN',
  },
  {
    name: 'Indonesia',
    code: 'ID',
  },
  {
    name: 'Iran',
    code: 'IR',
  },
  {
    name: 'Iraq',
    code: 'IQ',
  },
  {
    name: 'Ireland',
    code: 'IE',
  },
  {
    name: 'Isle of Man',
    code: 'IM',
  },
  {
    name: 'Israel',
    code: 'IL',
  },
  {
    name: 'Italy',
    code: 'IT',
  },
  {
    name: 'Jamaica',
    code: 'JM',
  },
  {
    name: 'Japan',
    code: 'JP',
  },
  {
    name: 'Jersey',
    code: 'JE',
  },
  {
    name: 'Jordan',
    code: 'JO',
  },
  {
    name: 'Kazakhstan',
    code: 'KZ',
  },
  {
    name: 'Kenya',
    code: 'KE',
  },
  {
    name: 'Kiribati',
    code: 'KI',
  },
  {
    name: 'Korea (North)',
    code: 'KP',
  },
  {
    name: 'Korea (South)',
    code: 'KR',
  },
  {
    name: 'Kosovo',
    code: 'XK',
  },
  {
    name: 'Kuwait',
    code: 'KW',
  },
  {
    name: 'Kyrgyzstan',
    code: 'KG',
  },
  {
    name: 'Laos',
    code: 'LA',
  },
  {
    name: 'Latvia',
    code: 'LV',
  },
  {
    name: 'Lebanon',
    code: 'LB',
  },
  {
    name: 'Lesotho',
    code: 'LS',
  },
  {
    name: 'Liberia',
    code: 'LR',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    code: 'LY',
  },
  {
    name: 'Liechtenstein',
    code: 'LI',
  },
  {
    name: 'Lithuania',
    code: 'LT',
  },
  {
    name: 'Luxembourg',
    code: 'LU',
  },
  {
    name: 'Macao',
    code: 'MO',
  },
  {
    name: 'Macedonia',
    code: 'MK',
  },
  {
    name: 'Madagascar',
    code: 'MG',
  },
  {
    name: 'Malawi',
    code: 'MW',
  },
  {
    name: 'Malaysia',
    code: 'MY',
  },
  {
    name: 'Maldives',
    code: 'MV',
  },
  {
    name: 'Mali',
    code: 'ML',
  },
  {
    name: 'Malta',
    code: 'MT',
  },
  {
    name: 'Marshall Islands',
    code: 'MH',
  },
  {
    name: 'Martinique',
    code: 'MQ',
  },
  {
    name: 'Mauritania',
    code: 'MR',
  },
  {
    name: 'Mauritius',
    code: 'MU',
  },
  {
    name: 'Mayotte',
    code: 'YT',
  },
  {
    name: 'Mexico',
    code: 'MX',
  },
  {
    name: 'Micronesia',
    code: 'FM',
  },
  {
    name: 'Moldova',
    code: 'MD',
  },
  {
    name: 'Monaco',
    code: 'MC',
  },
  {
    name: 'Mongolia',
    code: 'MN',
  },
  {
    name: 'Montserrat',
    code: 'MS',
  },
  {
    name: 'Morocco',
    code: 'MA',
  },
  {
    name: 'Mozambique',
    code: 'MZ',
  },
  {
    name: 'Myanmar',
    code: 'MM',
  },
  {
    name: 'Namibia',
    code: 'NA',
  },
  {
    name: 'Nauru',
    code: 'NR',
  },
  {
    name: 'Nepal',
    code: 'NP',
  },
  {
    name: 'Netherlands',
    code: 'NL',
  },
  {
    name: 'Netherlands Antilles',
    code: 'AN',
  },
  {
    name: 'New Caledonia',
    code: 'NC',
  },
  {
    name: 'New Zealand',
    code: 'NZ',
  },
  {
    name: 'Nicaragua',
    code: 'NI',
  },
  {
    name: 'Niger',
    code: 'NE',
  },
  {
    name: 'Nigeria',
    code: 'NG',
  },
  {
    name: 'Niue',
    code: 'NU',
  },
  {
    name: 'Norfolk Island',
    code: 'NF',
  },
  {
    name: 'Northern Mariana Islands',
    code: 'MP',
  },
  {
    name: 'Norway',
    code: 'NO',
  },
  {
    name: 'Oman',
    code: 'OM',
  },
  {
    name: 'Pakistan',
    code: 'PK',
  },
  {
    name: 'Palau',
    code: 'PW',
  },
  {
    name: 'Palestinian Territory, Occupied',
    code: 'PS',
  },
  {
    name: 'Panama',
    code: 'PA',
  },
  {
    name: 'Papua New Guinea',
    code: 'PG',
  },
  {
    name: 'Paraguay',
    code: 'PY',
  },
  {
    name: 'Peru',
    code: 'PE',
  },
  {
    name: 'Philippines',
    code: 'PH',
  },
  {
    name: 'Pitcairn',
    code: 'PN',
  },
  {
    name: 'Poland',
    code: 'PL',
  },
  {
    name: 'Portugal',
    code: 'PT',
  },
  {
    name: 'Puerto Rico',
    code: 'PR',
  },
  {
    name: 'Qatar',
    code: 'QA',
  },
  {
    name: 'Reunion',
    code: 'RE',
  },
  {
    name: 'Romania',
    code: 'RO',
  },
  {
    name: 'Russian Federation',
    code: 'RU',
  },
  {
    name: 'Rwanda',
    code: 'RW',
  },
  {
    name: 'Saint Helena',
    code: 'SH',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: 'KN',
  },
  {
    name: 'Saint Lucia',
    code: 'LC',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: 'PM',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: 'VC',
  },
  {
    name: 'Samoa',
    code: 'WS',
  },
  {
    name: 'San Marino',
    code: 'SM',
  },
  {
    name: 'Sao Tome and Principe',
    code: 'ST',
  },
  {
    name: 'Saudi Arabia',
    code: 'SA',
  },
  {
    name: 'Senegal',
    code: 'SN',
  },
  {
    name: 'Serbia',
    code: 'RS',
  },
  {
    name: 'Montenegro',
    code: 'ME',
  },
  {
    name: 'Seychelles',
    code: 'SC',
  },
  {
    name: 'Sierra Leone',
    code: 'SL',
  },
  {
    name: 'Singapore',
    code: 'SG',
  },
  {
    name: 'Slovakia',
    code: 'SK',
  },
  {
    name: 'Slovenia',
    code: 'SI',
  },
  {
    name: 'Solomon Islands',
    code: 'SB',
  },
  {
    name: 'Somalia',
    code: 'SO',
  },
  {
    name: 'South Africa',
    code: 'ZA',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: 'GS',
  },
  {
    name: 'Spain',
    code: 'ES',
  },
  {
    name: 'Sri Lanka',
    code: 'LK',
  },
  {
    name: 'Sudan',
    code: 'SD',
  },
  {
    name: 'Suriname',
    code: 'SR',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: 'SJ',
  },
  {
    name: 'Swaziland',
    code: 'SZ',
  },
  {
    name: 'Sweden',
    code: 'SE',
  },
  {
    name: 'Switzerland',
    code: 'CH',
  },
  {
    name: 'Syrian Arab Republic',
    code: 'SY',
  },
  {
    name: 'Taiwan, Province of China',
    code: 'TW',
  },
  {
    name: 'Tajikistan',
    code: 'TJ',
  },
  {
    name: 'Tanzania',
    code: 'TZ',
  },
  {
    name: 'Thailand',
    code: 'TH',
  },
  {
    name: 'Timor-Leste',
    code: 'TL',
  },
  {
    name: 'Togo',
    code: 'TG',
  },
  {
    name: 'Tokelau',
    code: 'TK',
  },
  {
    name: 'Tonga',
    code: 'TO',
  },
  {
    name: 'Trinidad and Tobago',
    code: 'TT',
  },
  {
    name: 'Tunisia',
    code: 'TN',
  },
  {
    name: 'Turkey',
    code: 'TR',
  },
  {
    name: 'Turkmenistan',
    code: 'TM',
  },
  {
    name: 'Turks and Caicos Islands',
    code: 'TC',
  },
  {
    name: 'Tuvalu',
    code: 'TV',
  },
  {
    name: 'Uganda',
    code: 'UG',
  },
  {
    name: 'Ukraine',
    code: 'UA',
  },
  {
    name: 'United Arab Emirates',
    code: 'AE',
  },
  {
    name: 'United Kingdom',
    code: 'GB',
  },
  {
    name: 'United States Minor Outlying Islands',
    code: 'UM',
  },
  {
    name: 'Uruguay',
    code: 'UY',
  },
  {
    name: 'Uzbekistan',
    code: 'UZ',
  },
  {
    name: 'Vanuatu',
    code: 'VU',
  },
  {
    name: 'Venezuela',
    code: 'VE',
  },
  {
    name: 'Viet Nam',
    code: 'VN',
  },
  {
    name: 'Virgin Islands, British',
    code: 'VG',
  },
  {
    name: 'Virgin Islands, U.S.',
    code: 'VI',
  },
  {
    name: 'Wallis and Futuna',
    code: 'WF',
  },
  {
    name: 'Western Sahara',
    code: 'EH',
  },
  {
    name: 'Yemen',
    code: 'YE',
  },
  {
    name: 'Zambia',
    code: 'ZM',
  },
  {
    name: 'Zimbabwe',
    code: 'ZW',
  },
];

export const requiredFn = (value: string) =>
  value ? undefined : 'This field is required.';

export const emailFn = (email: string) =>
  email && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(email)
    ? 'Must be valid email.'
    : undefined;

export const composeValidators = (
  ...validators: Array<(value: string) => undefined | string>
) => (value: string) =>
  validators.reduce(
    (error, validator) => error || validator(value),
    undefined as undefined | string,
  );

export const states = [
  { code: 'US', state: statesUSA, name: 'Your state?' },
  { code: 'CA', state: statesCanada, name: 'Your province?' },
  { code: 'BR', state: statesBrazil, name: 'Your state?' },
  { code: 'JP', state: statesJapan, name: 'Your prefecture?' },
  { code: 'AU', state: statesAustralia, name: 'Your state?' },
  { code: 'FR', state: statesFrance, name: 'Your province?' },
];
